/** Textos comuns da equipe da obra: Definir Equipe de Obra (HU 2050/2059) e a Etapa 4 "Equipe" do wizard (HU 2530). */

export const EQUIPE_TAB_PROFISSIONAIS = "Papéis e Profissionais";
export const EQUIPE_TAB_CALENDARIO = "Calendário de Alocação";
export const EQUIPE_TABS_LABEL = "Seções da equipe da obra";

// Aba "Calendário de Alocação" (HU 2059)
export const EQUIPE_CALENDARIO_SUBTITLE =
  "Verifique os conflitos e as outras obras e ausências programadas dos profissionais.";
export const EQUIPE_CALENDARIO_EMPTY =
  "Adicione profissionais na obra para analisar as obras e conflitos.";
export const CALENDARIO_LOAD_ERROR_MESSAGE = "Não foi possível carregar o calendário de alocação.";
export const CALENDARIO_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar a carga de trabalho.";
export const CALENDARIO_LOADING_MESSAGE = "Carregando calendário de alocação...";
export const CALENDARIO_RETRY_LABEL = "Tentar novamente";
export const CALENDARIO_HEADER_LABEL = "Profissional";
export const NOVA_OBRA_LABEL = "Nova Obra";
export const CALENDARIO_LEGENDA_LABEL = "Legenda:";
export const CALENDARIO_HOJE_LABEL = "Hoje";

export const EQUIPE_ADDED_LABEL = "Adicionado";

export const EQUIPE_SECTION_TITLE = "Equipe de Obra";
export const EQUIPE_ADD_PAPEL_LABEL = "Adicionar Papel";
export const EQUIPE_PAPEL_BUSCA_LABEL = "Buscar papel";
export const EQUIPE_PAPEIS_LABEL = "Papéis";
export const EQUIPE_PAPEL_EMPTY = "Nenhum papel encontrado.";
export const EQUIPE_EMPTY_MESSAGE = "Adicione um papel na Obra para começar.";
/** Tag do papel obrigatório no menu "Adicionar Papel" (Figma `9129:353249`). */
export const EQUIPE_PAPEL_OBRIGATORIO_TAG = "Obrigatório";

export const EQUIPE_COLUMN_NOME = "Nome";
export const EQUIPE_COLUMN_PAPEL = "Papel na Obra";
export const EQUIPE_COLUMN_INICIO = "Data Início";
export const EQUIPE_COLUMN_FIM = "Data Fim";
export const EQUIPE_COLUMN_ACOES = "Ações";

export const EQUIPE_PROFISSIONAL_PLACEHOLDER = "Selecione o profissional";
export const EQUIPE_PAPEL_PLACEHOLDER = "Selecione";
export const EQUIPE_PROFISSIONAL_EMPTY = "Nenhum profissional encontrado.";
export const EQUIPE_DISPONIVEL = "Disponível";
export const EQUIPE_INDISPONIVEL = "Indisponível";

export const EQUIPE_SELECT_PROFISSIONAL_MESSAGE =
  "Selecione um profissional para cada papel adicionado.";

export const EQUIPE_ADDED_TOAST = "Profissional adicionado à equipe.";
export const EQUIPE_UPDATED_TOAST = "Alterações salvas.";
export const EQUIPE_REMOVED_TOAST = "Profissional removido da equipe.";

export const dicaPapelObrigatorio = (rotulo: string) =>
  `Esse papel deve ser adicionado até ${rotulo} da Obra.`;

/* Modal "Equipe incompleta" (Figma 12227:420586). */
export const EQUIPE_INCOMPLETA_TITLE = "Equipe incompleta";
export const EQUIPE_INCOMPLETA_SUBTITLE = "Ainda há papéis obrigatórios sem profissional definido.";
export const EQUIPE_INCOMPLETA_INTRO_BEFORE = "A equipe da obra ";
export const EQUIPE_INCOMPLETA_INTRO_AFTER =
  " pode ser salva agora, mas os papéis pendentes precisam ser adicionados até a data limite.";
export const EQUIPE_INCOMPLETA_BACK = "Voltar e adicionar";
export const EQUIPE_INCOMPLETA_CONFIRM = "Salvar mesmo assim";
export const EQUIPE_INCOMPLETA_PAPEIS = "Papéis obrigatórios";
export const EQUIPE_INCOMPLETA_PENDING = "Pendente";
export const EQUIPE_INCOMPLETA_NONE = "Nenhum profissional adicionado";

/** Modo Simulação (HU 2225): nada é gravado, a equipe só entra no cenário. */
export const EQUIPE_INCOMPLETA_INTRO_AFTER_SIMULACAO =
  " pode entrar na simulação agora, mas os papéis pendentes precisam ser adicionados até a data limite.";
export const EQUIPE_INCOMPLETA_CONFIRM_SIMULACAO = "Aplicar na simulação mesmo assim";

/** "Ao salvar, o papel X vira uma pendência no menu Pendências." (na simulação, "Ao aplicar a simulação"). */
export function avisoPendenciaIncompleta(nomes: string[], simulacao = false): string {
  const quando = simulacao ? "Ao aplicar a simulação" : "Ao salvar";
  if (nomes.length <= 1) {
    return `${quando}, o papel ${nomes[0] ?? ""} vira uma pendência no menu Pendências.`;
  }

  const ultimo = nomes[nomes.length - 1];
  const anteriores = nomes.slice(0, -1).join(", ");
  return `${quando}, os papéis ${anteriores} e ${ultimo} viram pendências no menu Pendências.`;
}

/* Modais de verificação, na ordem do Salvar (HU 2059): conflito e indisponibilidade. */
export const JUSTIFICATIVA_LABEL = "Justificativa";
export const JUSTIFICATIVA_REQUIRED_HINT = "(Campo obrigatório)";
export const JUSTIFICATIVA_REQUIRED_MESSAGE = "Informe a justificativa para confirmar.";
export const VOLTAR_LABEL = "Voltar";
export const CONFIRMAR_LABEL = "Confirmar";
/** Limite padrão da justificativa dos diálogos de verificação (o core aceita 255). */
export const JUSTIFICATIVA_MAX_LENGTH = 255;

/* Modal "Conflitos de alocação identificados" (Figma 12227:420479). */
export const CONFLITOS_TITLE = "Conflitos de alocação identificados";
export const CONFLITOS_SUBTITLE =
  "Revise os conflitos antes de confirmar a definição da equipe de obra.";
export const OBRA_ATUAL_LABEL = "Obra atual";
export const NOVA_ALOCACAO_LABEL = "Nova alocação";
export const CONFLITOS_JUSTIFICATIVA_PLACEHOLDER =
  "Digite a justificativa para a alocação com conflito...";

/** "O profissional **Ana** (Coordenador) está alocado em outra obra durante o período." */
export const conflitoIntro = (papel?: string) => ({
  antes: "O profissional ",
  depois: `${papel ? ` (${papel})` : ""} está alocado em outra obra durante o período.`,
});

/**
 * Aviso do card (Figma 12227:420479): a obra atual coincide com a nova. Com `trecho`, o aviso cita o trecho
 * coincidente (Definir Equipe); sem ele, o período fica só nos cartões acima (Nova Obra).
 */
export const conflitoCoincidencia = (obraCodigo: string, trecho?: string) =>
  `A alocação na obra ${obraCodigo} coincide com o período da nova obra${trecho ? `: ${trecho}` : ""}.`;

export const conflitosCiencia = (obra: string, varios: boolean) =>
  varios
    ? `Ao confirmar, você reconhece que estes profissionais possuem conflitos de alocação e poderão não estar totalmente disponíveis para a obra ${obra}.`
    : `Ao confirmar, você reconhece que este profissional possui conflito de alocação e poderá não estar totalmente disponível para a obra ${obra}.`;

/* Modal "Profissional indisponível" (Figma 12227:420433): sem motivo nem tipo da ausência. */
export const INDISPONIVEL_TITLE = "Profissional indisponível";
export const INDISPONIVEL_SUBTITLE =
  "Verifique a disponibilidade antes de confirmar a alocação na obra.";
export const INDISPONIVEL_INTRO = {
  antes: "O profissional ",
  depois: " está com uma ausência programada que coincide com o período da obra.",
};
export const PERIODO_OBRA_LABEL = "Período da obra";
export const PERIODO_INDISPONIVEL_LABEL = "Período Indisponível";
export const INDISPONIVEL_AVISO =
  "O profissional não estará disponível durante parte do período da obra.";
export const INDISPONIVEL_CIENCIA =
  "Ao confirmar, você reconhece que este profissional pode não estar disponível para a obra.";

export const EQUIPE_DATA_PLACEHOLDER = "DD/MM/AAAA";
